import { render, staticRenderFns } from "./OperaLabelKnowledgeWindow.vue?vue&type=template&id=80897d5a&scoped=true&"
import script from "./OperaLabelKnowledgeWindow.vue?vue&type=script&lang=js&"
export * from "./OperaLabelKnowledgeWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaLabelKnowledgeWindow.vue?vue&type=style&index=0&id=80897d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80897d5a",
  null
  
)

export default component.exports